import { $window } from '@umu/umu-dom';
import { useLoadedScript } from '@umu/umu-react-hooks';
import { IUserInfo, IWaterMarkProps, ResourceStatus } from '@umu/umu-types';
import { Loading } from 'common/src/components';
import React, { useEffect, useState } from 'react';
import { configRenderHelper } from './services/configRenderHelper';

import { IPdfImages } from './base';
import DocReader from './docReader';
import { DocReaderProvider } from './store/docReaderContext';
import { getPdfJs } from './util';

type screenType = 'no-full' | 'full';

interface IProps {
    style?: React.CSSProperties;
    className?: string;
    documentTitle?: string;
    offsetTop?: number; // 顶部偏移量
    userInfo?: IUserInfo;
    isShowWatermark?: boolean; // 是否开启水印
    waterMarkOptions?: IWaterMarkProps;
    resourceUrl: string; // 文档 recourse url
    pdfImages?: IPdfImages; // pdf 图片列表
    initPageNum?: any; // 初始页码
    containerHeight?: number; // 限制容器高度
    screenState?: screenType; // 全屏状态
    screenCallback?: (isFullscreen: boolean) => void; // 全屏按钮回调
    transStatus?: ResourceStatus; // 转码状态
    pageChangeCallback?: (pageNum: number, allPageNum: number) => void; // 页码切换回调
    elementId?: string;
}

export const PdfReader = (props: IProps) => {
    const [isLoadedConfig, setLoadedConfig] = useState<boolean>(false);
    let pdfIsLoaded = useLoadedScript([getPdfJs()], () => {
        return !$window.pdfjsLib;
    });

    if ($window.pdfjsLib) {
        pdfIsLoaded = true;
    }

    useEffect(() => {
        configRenderHelper.onConfigLoaded((isLoaded) => {
            setLoadedConfig(isLoaded);
        });
        configRenderHelper.loadConfig();
    }, []);

    if (!pdfIsLoaded || !isLoadedConfig) {
        return <Loading />;
    }
    return (
        <DocReaderProvider>
            <DocReader {...props} />
        </DocReaderProvider>
    );
};
